<ng-container *ngIf="dialect"
              #container>

  <div class="head-tit-box">

    <div class="head-txt-box">

      <div class="tit-box">{{ dialect.word }}</div>

      <div class="place-box">
        <article class="place-list-layout">
          <div class="place-label-list">

            <div class="place-label-box main-type{{ GetRegion2Css(dialect.area1) }}">
              {{ dialect.area1 }}
            </div>

            <!-- div *ngIf="dialect.area2"
                 class="place-label-box sub-type{{ GetRegion2Css(dialect.area1) }}">
              {{ dialect.area2 }}
            </div -->

          </div>
        </article>
      </div>
    </div>

    <div class="option-list">
      <div class="option-box">
        <article class="bookmark-btn-box">
          <a class="bookmark-btn type-big {{ getBmCss(dialect) }}"
             (click)="ToggleBookmark($event, dialect)"></a>
        </article>
      </div>

      <div class="option-box">
        <a class="toggle-btn"
           (click)="onOpen($event)"></a>
      </div>

    </div>


  </div>

  <!-- div class="head-des-box" [innerHTML]="dialect.meaning2 | resize | keepHtml"></div -->
</ng-container>
